export default "__VITE_ASSET__76e77fe3__"